// Mirrors apps/web/app/composables/useHrefLinks.ts
import { computed } from 'vue';
import { useRuntimeConfig } from 'nuxt/app';
import { defaultLocale } from '@pkg/config/languages';
import { LOCALE_CODE } from '@pkg/config/languages/localeCodes';
import { DOCUMENT } from '@pkg/config/sanity/schemas';

interface Translation {
  title?: string;
  slug?: string;
  language?: string;
}

interface LinkData {
  rel?: string;
  href?: string;
  hreflang?: string;
}

const getSlugParent = (docType?: string) => {
  switch (docType) {
    case DOCUMENT.ABOUT_FOOD_WASTE_BLOG:
      return '/blog/';
    case DOCUMENT.PRESS_RELEASES:
      return '/press/';
    default:
      return '';
  }
};

/**
 * Localised hrefs for hreflang alternates. Used by the business slug page.
 */
export function useHrefLinks(route: { path: string }) {
  const { public: { domain } } = useRuntimeConfig();

  const getLocalizedHref = (
    linkData: LinkData,
    pageTranslations: Array<Translation | null> | undefined,
    docType?: string,
  ) => {
    const routeLocaleCode = computed(() => route.path.substring(1).replace(/\/+$/, ''));
    const isLocaleCode = computed(() => Object.values(LOCALE_CODE).includes(routeLocaleCode.value as LOCALE_CODE));
    const isHomeRoute = computed(() => routeLocaleCode.value === '' || isLocaleCode.value);

    let hrefLink = '';
    if (linkData.hreflang !== defaultLocale) {
      hrefLink = linkData.hreflang ? `/${linkData.hreflang}` : `/${routeLocaleCode.value}`;
    }

    if (isHomeRoute.value) { return `${domain}${hrefLink}`; }

    const translation = pageTranslations && pageTranslations.find(
      item => item?.language === linkData.hreflang,
    );

    const translationSlug = `${getSlugParent(docType)}${translation?.slug}`;

    return translation ? `${domain}${hrefLink}${translationSlug}` : null;
  };

  return {
    getLocalizedHref,
  };
}
